import { Switch as MuiSwitch, SwitchProps, SxProps, Theme } from '@mui/material';

const customStyles: SxProps<Theme> = {
  width: '30px',
  height: '20px',
  padding: '0px',
  '& .MuiSwitch-switchBase': {
    padding: '0px 0px',
    margin: '0px',
    transitionDuration: '300ms',
    '&.Mui-checked': {
      transform: 'translateX(12px)',
      color: '#fff',
      '& + .MuiSwitch-track': {
        backgroundColor: '#D8EFFE',
        opacity: 1,
        border: (theme) => `2px solid ${theme.palette.primary.main}`,
      },
      '& .MuiSwitch-thumb': {
        borderColor: (theme) => theme.palette.primary.main,
      },
      '&.Mui-disabled + .MuiSwitch-track': {
        opacity: 0.5,
      },
    },
    '&.Mui-focusVisible .MuiSwitch-thumb': {
      color: '#33cf4d',
    },
    '&.Mui-disabled .MuiSwitch-thumb': {
      color: (theme) => theme.palette.grey[100],
    },
    '&.Mui-disabled + .MuiSwitch-track': {
      border: '2px solid #B8BABF',
      opacity: 0.7,
    },
  },
  '& .MuiSwitch-thumb': {
    boxSizing: 'border-box',
    width: '18px',
    height: '18px',
    border: '2px solid #B8BABF',
    boxShadow: 'unset',
  },
  '& .MuiSwitch-track': {
    borderRadius: '16px',
    backgroundColor: '#E9E9EA',
    opacity: 1,
    height: '18px',
    border: '2px solid #B8BABF',
    transition: (theme: Theme) =>
      theme.transitions.create(['background-color'], {
        duration: 500,
      }),
  },
};

export function Switch(props: SwitchProps) {
  return (
    <>
      <MuiSwitch
        sx={{ ...customStyles, ...props.sx } as SxProps<Theme>}
        {...props}
      />
    </>
  );
}
